declare global {
  interface Window {
    digitalData: any;
    cookiedUser: "true" | "false";
    storeUserType: "G" | "R";
    GlobalLoginJS: {
      InitHTTPSecure: (input: "Header_GlobalLogin") => void;
    };
    tableGroupingJSON:any
  }
}

import App from "./App.svelte";
import "./app.css";

let app;
try {
  app = new App({
    target: document.getElementById("TableView-id")!,
    props: { staticTableResponse: window.tableGroupingJSON },
  });
} catch (e) {
  console.error("Setup error: Please ensure that the 'id' provided for target is correct.", e);
  console.error(
    "%cIf this is the first time creating/running project, please use `node create-hds` in the root of the repo",
    "font-size: 18px; font-weight: bold; color: red;",
  );
}
export default app;
